var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("Spinner", { attrs: { id: "spinner", "is-loading": _vm.isLoading } }),
      !_vm.isLoading
        ? _c(
            "div",
            { staticClass: "card-item", attrs: { id: "toggles-container" } },
            _vm._l(_vm.toggles, function (toggle, i) {
              return _c(
                "div",
                {
                  key: toggle.name,
                  staticClass: "toggle card-item shadowless",
                  attrs: { id: toggle.name },
                },
                [
                  _c(
                    "div",
                    { staticClass: "toggle-body" },
                    [
                      _c(
                        "b-field",
                        { staticClass: "is-pulled-right" },
                        [
                          _c("b-switch", {
                            attrs: {
                              type: "is-success",
                              size: "is-small",
                              disabled:
                                !_vm.checkAllUserFeature(toggle.name) ||
                                toggle.isDisabled,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.updateFeatureToggle(
                                  i,
                                  toggle._id,
                                  $event
                                )
                              },
                            },
                            model: {
                              value: toggle.isActive,
                              callback: function ($$v) {
                                _vm.$set(toggle, "isActive", $$v)
                              },
                              expression: "toggle.isActive",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "p",
                        {
                          staticClass: "title is-size-6 has-text-primary mb-0",
                        },
                        [_vm._v(_vm._s(toggle.name))]
                      ),
                      _c("p", [
                        _c("small", [_vm._v(_vm._s(toggle.description))]),
                      ]),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "is-clearfix toggle-footer" }, [
                    toggle.options && toggle.options.length > 0
                      ? _c(
                          "button",
                          {
                            staticClass:
                              "is-pulled-right button is-button-secondary is-rounded",
                            attrs: {
                              disabled: !_vm.checkAllUserFeature(toggle.name),
                            },
                            on: {
                              click: function ($event) {
                                return _vm.extendOption(i)
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "icon is-small" }, [
                              _c("i", {
                                staticClass: "fas",
                                class:
                                  _vm.extendedOptions === i
                                    ? "fa-chevron-up"
                                    : "fa-chevron-down",
                              }),
                            ]),
                            _c("span", [_vm._v("Opciones")]),
                          ]
                        )
                      : _vm._e(),
                  ]),
                  toggle.options && toggle.options.length > 0
                    ? _c(
                        "div",
                        {
                          staticClass: "toggle-options",
                          class: {
                            "hidden-options": _vm.extendedOptions !== i,
                          },
                        },
                        [
                          _vm._l(toggle.options, function (option) {
                            return _c(
                              "b-field",
                              {
                                key: option.key,
                                attrs: {
                                  label: option.description,
                                  "custom-class": "has-text-weight-normal",
                                },
                              },
                              [
                                typeof option.value === "number"
                                  ? _c("b-numberinput", {
                                      staticClass: "number-input",
                                      attrs: {
                                        id: `option${option.key}`,
                                        min: "0",
                                        size: "is-small",
                                        "controls-rounded": "",
                                        rounded: "",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.$set(
                                            toggle,
                                            "hasChanged",
                                            true
                                          )
                                        },
                                      },
                                      model: {
                                        value: option.value,
                                        callback: function ($$v) {
                                          _vm.$set(option, "value", $$v)
                                        },
                                        expression: "option.value",
                                      },
                                    })
                                  : _vm._e(),
                                typeof option.value === "string"
                                  ? _c("b-input", {
                                      attrs: {
                                        id: `option${option.key}`,
                                        size: "is-small",
                                        rounded: "",
                                        placeholder:
                                          "Debes ingresar un valor...",
                                      },
                                      on: {
                                        input: function ($event) {
                                          return _vm.$set(
                                            toggle,
                                            "hasChanged",
                                            true
                                          )
                                        },
                                      },
                                      model: {
                                        value: option.value,
                                        callback: function ($$v) {
                                          _vm.$set(option, "value", $$v)
                                        },
                                        expression: "option.value",
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            )
                          }),
                          toggle.hasChanged
                            ? _c(
                                "button",
                                {
                                  staticClass:
                                    "is-pulled-right button is-button-primary is-rounded",
                                  attrs: { disabled: toggle.isDisabled },
                                  on: {
                                    click: function ($event) {
                                      return _vm.updateFeatureToggle(
                                        i,
                                        toggle._id,
                                        toggle.isActive,
                                        toggle.options
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("span", { staticClass: "icon is-small" }, [
                                    _c("i", {
                                      staticClass: "fas",
                                      class: toggle.isDisabled
                                        ? "fa-cog fa-spin"
                                        : "fa-save",
                                    }),
                                  ]),
                                  _c("span", [_vm._v("Guardar")]),
                                ]
                              )
                            : _vm._e(),
                        ],
                        2
                      )
                    : _vm._e(),
                ]
              )
            }),
            0
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }